import React, { Component } from 'react'

class CatchGlobalClick extends Component {
  componentWillMount() {
    document.addEventListener('click', this.handleGlobalClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleGlobalClick, false)
  }

  handleGlobalClick = (event) => {
    if (this.element && !this.element.contains(event.target)) {
      if (this.props.onClick) {
        this.props.onClick()
      }
    }
  }

  render() {
    return (
      <div ref={(e) => { this.element = e }}>
        {this.props.children}
      </div>
    )
  }
}

export default CatchGlobalClick



// WEBPACK FOOTER //
// ./src/components/CatchGlobalClick/index.js